/*
 * @FilePath: accessControl.js
 * @Author: Aron
 * @Date: 2023-07-18 19:11:10
 * @LastEditors: Please set LastEditors
 * @LastEditTime: 2023-07-18 19:11:17
 * Copyright: 2023 xxxTech CO.,LTD. All Rights Reserved.
 * @Descripttion:
 */
import * as keys from '@/util/keys'

export const unlocking = (key, data = '[]') => {
  let userInfo = localStorage.getItem(keys.CRM_FUNC_KEYS) || data
  
  userInfo = JSON.parse(userInfo)
  // if (userInfo) {
  //     var { SysFunctions } = userInfo;
  // }
  if (key instanceof Array) {
    let operation = false
    for (var j in key) {
      for (var i in userInfo) {
        if (key[j] === userInfo[i].functionKey) {
          operation = true
          break
        }
      }
    }
    return operation
  }
  for (var s in userInfo) {
    if (userInfo[s].functionKey === key) {
      return true
    }
  }
  return false
}
